
export default {
  name: 'Share',
  props: {
    socialData: {
      type: Object,
      required: true,
    },
  },
}
